import React, {useState, useEffect, useCallback, useRef} from "react";
import styles from "./App.module.css";
import {ThemeProvider, useTheme} from "../ThemeContext/ThemeContext";
import useNotifications from "../../hooks/useNotifications";
import AppRouter from "../AppRouter/AppRouter";
import LocationLoadingScreen from "../LocationLoadingScreen/LocationLoadingScreen";
import {GeolocationProvider, useGeolocation} from "../../contexts/GeolocationProvider";
import {UserActionsProvider} from "../../contexts/UserActionsContext";
import {Helmet} from "react-helmet";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error("Uncaught error:", error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return <h1>Something went wrong.</h1>;
        }

        return this.props.children;
    }
}

const AppContent = () => {
    const [user, setUser] = useState(null);
    const { geoposition, dateObject, isLoading, error, locationLoading } = useGeolocation();

    useEffect(() => {
        // Run detection when DOM is loaded
        detectBrowserAndOS();
    }, []);

    const detectBrowserAndOS = () => {
        const userAgent = navigator.userAgent.toLowerCase();
        let browserName = '';
        let osName = '';

        // Detect Browser
        if (userAgent.includes('edge')) {
            browserName = 'edge';
        } else if (userAgent.includes('firefox')) {
            browserName = 'firefox';
        } else if (userAgent.includes('opr') || userAgent.includes('opera')) {
            browserName = 'opera';
        } else if (userAgent.includes('chrome')) {
            browserName = 'chrome';
        } else if (userAgent.includes('safari')) {
            browserName = 'safari';
        } else {
            browserName = 'unknown-browser';
        }

        // Detect OS
        if (userAgent.includes('win')) {
            osName = 'windows';
        } else if (userAgent.includes('mac')) {
            osName = 'macos';
        } else if (userAgent.includes('linux')) {
            osName = 'linux';
        } else if (userAgent.includes('android')) {
            osName = 'android';
        } else if (userAgent.includes('ios')) {
            osName = 'ios';
        } else {
            osName = 'unknown-os';
        }

        document.body.classList.add(browserName, osName);
    };

    useEffect(() => {
        // Hide splash screen
        const splashScreen = document.getElementById('splash-screen');
        if (splashScreen) {
            splashScreen.classList.add('hidden');
            setTimeout(() => {
                splashScreen.style.display = 'none';
            }, 1000);
        }
    }, []);


    if (isLoading) {
        return <LocationLoadingScreen/>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <div id="MainApp" className={styles.App}>
            {geoposition ? (
                <AppRouter
                    user={user}
                    geoposition={geoposition}
                    dateObject={dateObject}
                    locationLoading={locationLoading}
                />
            ) : (
                 <LocationLoadingScreen/>
             )}

        </div>
    );
};

const App = () => {
    return (

        <ThemeProvider>
            <GeolocationProvider>
                <UserActionsProvider>
                    <Helmet>
                        <meta id="meta-description" name="description" content="Shop & Save Weed Deals Near You. pluug is the place to find every deal. Everywhere." />
                        <meta id="meta-keywords" name="keywords" content="pluug, cannabis deals, marijuana discounts, weed specials, cannabis coupons..." />
                        <meta name="keywords" content="pluug, cannabis deals, marijuana discounts, weed specials, cannabis coupons, dispensary deals, cannabis price comparison, marijuana savings, cannabis marketplace, weed offers, cannabis promotions, legal cannabis, dispensary finder, cannabis products, marijuana delivery, cannabis shopping, best cannabis prices, cannabis strains, local dispensaries, cannabis community" />

                    </Helmet>
                    <AppContent/>
                </UserActionsProvider>
            </GeolocationProvider>
        </ThemeProvider>

    );
};

export default App;
